export default __webpack_public_path__ + "static/media/mitsuha-unties-hair.9e89657f.gif";